// extracted by mini-css-extract-plugin
export var borderTop = "_x-3";
export var linkIcon = "_x-5";
export var linkIconSm = "_x-6";
export var linkOutCard = "_x-7 _x-4";
export var linkRow = "_x-2";
export var pageContainer = "_x-1";
export var providerIcon = "_x-8";
export var roundedBorder = "_x-4";
export var settingsContent = "_x-0";